import {defineStore} from 'pinia';

export const useLayoutStore = defineStore({
	id: 'LayoutStore',
	state: () => ({
		contentReady: false,
	}),
	actions: {
		markContentReady() {
			this.contentReady = true;
		},
	},
});
